import { aboutContent } from '@/mocks/siteData';

export default function Values() {
  return (
    <section className="py-10 md:py-14">
      <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-8 text-center">
        我们的价值观
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {aboutContent.values.map((v) => (
          <div key={v.title} className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3">{v.title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{v.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}